    <div class="user-info">    
        @if(auth.isLoading()) {
            <nz-spin nzSimple />
        }
        @else {
            @if (auth.loggedIn()) {
                
                <div>
                    <a nz-dropdown [nzDropdownMenu]="menu">
                        <div class="user-avatar">
                            <nz-avatar nzText="{{ auth.userName()[0] }}"></nz-avatar>
                        </div>
                        <nz-icon nzType="down" />
                    </a>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                            <li nz-submenu [nzTitle]="selectedTenantName()">
                                 <ul>
                                  @for (tenant of availableTenants(); track tenant.companyId) {
                                    <li nz-menu-item
                                        (click)="tenant.companyId && userStore.setCurrentTenant(tenant)">
                                        {{ tenant.tenantName }}
                                    </li>
                                    }
                                 </ul>
                            </li>
                            <li nz-menu-item class="user-menu-item"> 
                                <span class="username">{{ auth.userName() }}</span>
                                <a nz-button nzType="link" nzSize="small" (click)="auth.logout()">Wyloguj</a>
                            </li>
                        </ul>
                    </nz-dropdown-menu>
                </div>
            }
        }
    </div>